export default __webpack_public_path__ + "static/media/request_postman.e90bb81c.PNG";